import axios from 'axios'
import {server_base_url} from '../../../shared'

export const addSampleIDAPI = async(sampleid, sampleenabled) => {

  const sample_id = sampleid
  const sample_enabled = sampleenabled

  const accessToken = JSON.parse(localStorage.getItem('userInfo')).auth0_access_token
  const url = `${server_base_url}/sampleids`
  const config = {
      headers:{
          'Content-Type':'application/json',
          "X-AuthorityToken": "auth-wpf-desktop",
          "X-AccessToken" : accessToken
      }
  }

  const jsondata = {
      sample_id: sample_id,
      sample_enabled: sample_enabled
    }

  const {data} = await axios.post(
      url,
      jsondata,
      config
  )

  return data
}

export const updateSampleIDAPI = async(id, sampleid, sampleenabled) => {
  const accessToken = JSON.parse(localStorage.getItem('userInfo')).auth0_access_token
  const url = `${server_base_url}/sampleids`
  const config = {
      headers:{
          'Content-Type':'application/json',
          "X-AuthorityToken": "auth-wpf-desktop",
          "X-AccessToken" : accessToken
      }
  }
  const jsondata = {
      id: id,
      sample_id: sampleid,
      sample_enabled: sampleenabled
    }
  const {data} = await axios.put(
      url,
      jsondata,
      config
  )
  return data
}

export const deleteSampleIDAPI = async(id) => {
  const accessToken = JSON.parse(localStorage.getItem('userInfo')).auth0_access_token
  const url = `${server_base_url}/sampleid/${id}`
  const config = {
      headers:{
          'Content-Type':'application/json',
          "X-AuthorityToken": "auth-wpf-desktop",
          "X-AccessToken" : accessToken
      }
  }

  const {data} = await axios.delete(
      url,
      config
  )
  return data
}

//TEST Panel APIs
export const addTestPanelAPI = async(testpanelid, enabled) => {

  const test_panel_id = testpanelid
  const test_panel_enabled = enabled

  const accessToken = JSON.parse(localStorage.getItem('userInfo')).auth0_access_token
  const url = `${server_base_url}/testpanels`
  const config = {
      headers:{
          'Content-Type':'application/json',
          "X-AuthorityToken": "auth-wpf-desktop",
          "X-AccessToken" : accessToken
      }
  }

  const jsondata = {
      test_panel_id: test_panel_id,
      test_panel_enabled: test_panel_enabled
    }

  var data;
  try{
    data = await axios.post(
        url,
        jsondata,
        config
    )
    data = data.data
  }catch (error) {
    console.log(error)
  }

  return data
}

export const updateTestPanelAPI = async(id, sampleid, enabled) => {

  const _id = id
  const test_panel_id = sampleid
  const test_panel_enabled = enabled

  const accessToken = JSON.parse(localStorage.getItem('userInfo')).auth0_access_token
  const url = `${server_base_url}/testpanels`
  const config = {
      headers:{
          'Content-Type':'application/json',
          "X-AuthorityToken": "auth-wpf-desktop",
          "X-AccessToken" : accessToken
      }
  }

  const jsondata = {
      id: _id,
      test_panel_id: test_panel_id,
      test_panel_enabled: test_panel_enabled
    }

  var data;
  try{
    data = await axios.put(
        url,
        jsondata,
        config
    )
    data = data.data
  }catch (error) {
    console.log(error)
  }
  return data
}

export const deleteTestPanelAPI = async(id) => {
  const accessToken = JSON.parse(localStorage.getItem('userInfo')).auth0_access_token
  const url = `${server_base_url}/testpanel/${id}`
  const config = {
      headers:{
          'Content-Type':'application/json',
          "X-AuthorityToken": "auth-wpf-desktop",
          "X-AccessToken" : accessToken
      }
  }

  var data;
  try{
    data = await axios.delete(
        url,
        config
    )
    data = data.data
  }catch (error) {
    console.log(error)
  }
  return data
}
